module.exports = __webpack_public_path__ + "static/media/issam.b0edef32.jpg";